define("media/components/media/asset-card", ["exports", "@ember/component", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "progressbar.js", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _utils, _component2, _tracking, _progressbar, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _drawProgressCircle, _select, _toggleSelection, _uploadProgress;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"progressbar.js",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{this.classNames}}
    data-media-item-id={{this.modelId}}
    {{did-insert this.handleInsert}}
    {{did-update this.handleUpdate @mediaItem.uploadProgress @mediaItem.isUploading @mediaItem.mediaLibraryImageUrl}}
    {{on "click" this.handleClick}}
  >
    <div class="o--card {{if this.isSelected 'is--selected'}}">
      <figure class="o--mediaContainer">
        {{#if this.isUploading}}
          <div class="e--upload-progress" data-upload-id={{this.modelId}} id={{this.progressCircleUUID}}></div>
        {{else}}
          <img class="o--media" data-media-item-id={{this.media.id}} src={{this.mediaUrl}} />
  
          <b class="o--mediaOverlay"></b>
          {{#if this.media.isVideo}}
            <span class="o--media__label--type">
              {{svg-jar "video" class="o--icon--md o--icon--white"}}
            </span>
          {{/if}}
          {{#if this.media.isGif}}
            <span class="o--media__label--type">
              {{svg-jar "gif" class="o--icon--md o--icon--white"}}
            </span>
          {{/if}}
          {{#if this.needsApproval}}
            <span class="o--mediaOverlay">
              <span class="img--overlay__pending"></span>
            </span>
          {{/if}}
          {{#unless this.media.isUploading}}
            <span class="o--media__label--select">
              <span class="o--media__label--check" {{on "click" this.toggleSelection}}>
                {{#if this.isSelected}}
                  {{svg-jar "verified" class="o--icon o--icon--white o--media__labelIcon is--checked"}}
                {{else}}
                  {{svg-jar "verified" class="o--icon o--icon--white o--media__labelIcon is--unchecked"}}
                {{/if}}
              </span>
              <span class="o--media__label--star" {{on "click" this.toggleStarred}}>
                {{#if this.media.isStarred}}
                  {{svg-jar "starred" class="o--icon--md o--icon--white o--media__labelIcon is--starred"}}
                {{else}}
                  {{svg-jar "star" class="o--icon--md o--icon--white o--media__labelIcon is--unstarred"}}
                {{/if}}
              </span>
            </span>
          {{/unless}}
        {{/if}}
      </figure>
      <div class="o--card__content">
        <div class="o--card__action--hide cLB--nowrapWrapper" {{perfect-scroll}}>
          {{#each this.media.labels as |label|}}
            <span class="cLB--label--sm {{if label.isSystemLabel 'cLB--label--system'}}">
              {{label.canonicalTagName}}
            </span>
          {{/each}}
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "J9/D8aUQ",
    "block": "[[[11,0],[16,0,[30,0,[\"classNames\"]]],[16,\"data-media-item-id\",[30,0,[\"modelId\"]]],[4,[38,0],[[30,0,[\"handleInsert\"]]],null],[4,[38,1],[[30,0,[\"handleUpdate\"]],[30,1,[\"uploadProgress\"]],[30,1,[\"isUploading\"]],[30,1,[\"mediaLibraryImageUrl\"]]],null],[4,[38,2],[\"click\",[30,0,[\"handleClick\"]]],null],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[\"o--card \",[52,[30,0,[\"isSelected\"]],\"is--selected\"]]]],[12],[1,\"\\n    \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n\"],[41,[30,0,[\"isUploading\"]],[[[1,\"        \"],[10,0],[14,0,\"e--upload-progress\"],[15,\"data-upload-id\",[30,0,[\"modelId\"]]],[15,1,[30,0,[\"progressCircleUUID\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"data-media-item-id\",[30,0,[\"media\",\"id\"]]],[15,\"src\",[30,0,[\"mediaUrl\"]]],[12],[13],[1,\"\\n\\n        \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n\"],[41,[30,0,[\"media\",\"isVideo\"]],[[[1,\"          \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"video\"],[[\"class\"],[\"o--icon--md o--icon--white\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"media\",\"isGif\"]],[[[1,\"          \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"gif\"],[[\"class\"],[\"o--icon--md o--icon--white\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"needsApproval\"]],[[[1,\"          \"],[10,1],[14,0,\"o--mediaOverlay\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"img--overlay__pending\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[51,[30,0,[\"media\",\"isUploading\"]]],[[[1,\"          \"],[10,1],[14,0,\"o--media__label--select\"],[12],[1,\"\\n            \"],[11,1],[24,0,\"o--media__label--check\"],[4,[38,2],[\"click\",[30,0,[\"toggleSelection\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isSelected\"]],[[[1,\"                \"],[1,[28,[35,4],[\"verified\"],[[\"class\"],[\"o--icon o--icon--white o--media__labelIcon is--checked\"]]]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,4],[\"verified\"],[[\"class\"],[\"o--icon o--icon--white o--media__labelIcon is--unchecked\"]]]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n            \"],[11,1],[24,0,\"o--media__label--star\"],[4,[38,2],[\"click\",[30,0,[\"toggleStarred\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"media\",\"isStarred\"]],[[[1,\"                \"],[1,[28,[35,4],[\"starred\"],[[\"class\"],[\"o--icon--md o--icon--white o--media__labelIcon is--starred\"]]]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,4],[\"star\"],[[\"class\"],[\"o--icon--md o--icon--white o--media__labelIcon is--unstarred\"]]]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--card__content\"],[12],[1,\"\\n      \"],[11,0],[24,0,\"o--card__action--hide cLB--nowrapWrapper\"],[4,[38,6],null,null],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"media\",\"labels\"]]],null]],null],null,[[[1,\"          \"],[10,1],[15,0,[29,[\"cLB--label--sm \",[52,[30,2,[\"isSystemLabel\"]],\"cLB--label--system\"]]]],[12],[1,\"\\n            \"],[1,[30,2,[\"canonicalTagName\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@mediaItem\",\"label\"],false,[\"did-insert\",\"did-update\",\"on\",\"if\",\"svg-jar\",\"unless\",\"perfect-scroll\",\"each\",\"-track-array\"]]",
    "moduleName": "media/components/media/asset-card.hbs",
    "isStrictMode": false
  });
  let AssetCardComponent = _exports.default = (_class = (_drawProgressCircle = /*#__PURE__*/new WeakSet(), _select = /*#__PURE__*/new WeakSet(), _toggleSelection = /*#__PURE__*/new WeakSet(), _uploadProgress = /*#__PURE__*/new WeakSet(), class AssetCardComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _uploadProgress);
      _classPrivateMethodInitSpec(this, _toggleSelection);
      _classPrivateMethodInitSpec(this, _select);
      _classPrivateMethodInitSpec(this, _drawProgressCircle);
      _initializerDefineProperty(this, "circle", _descriptor, this);
      _initializerDefineProperty(this, "media", _descriptor2, this);
      _initializerDefineProperty(this, "mediaUrl", _descriptor3, this);
      _defineProperty(this, "progressCircleUUID", (0, _uuid.default)());
      this.media = this.args.mediaItem;
      this.mediaUrl = this.args.mediaItem.mediaLibraryImageUrl;
    }
    get classNames() {
      const isSelected = this.isSelected ? 'ui-selected' : '';
      const isUploading = this.isUploading ? '' : 'ui-selectee eME--selectable';
      const isMultiselected = this.isMultiselected ? '' : 'is--multiselect';
      return `o--cardContainer cME--cardContainer is--square is--imageOnly ${isSelected} ${isUploading} ${isMultiselected}`;
    }
    get isMultiselected() {
      return (0, _utils.isEmpty)(this.args.selectedAssets);
    }
    get isSelected() {
      return this.args.selectedAssets.includes(this.media);
    }
    get isUploading() {
      return this.media.isUploading;
    }
    get modelId() {
      return this.media.id;
    }
    get needsApproval() {
      return this.media.needsApproval;
    }
    handleClick(event) {
      if (!this.media.isUploading) {
        if (this.args.selectedAssets.length > 0 || typeof event !== 'undefined' && (event.altKey || event.metaKey)) {
          _classPrivateMethodGet(this, _toggleSelection, _toggleSelection2).call(this);
        } else {
          this.args.openAssetModal(this.media);
        }
      }
    }
    handleInsert() {
      if (this.media.isUploading) {
        _classPrivateMethodGet(this, _drawProgressCircle, _drawProgressCircle2).call(this);
      }
    }
    handleUpdate() {
      if (!this.media?.isUploading) {
        this.media = this.args.mediaItem;
        this.mediaUrl = this.args.mediaItem.mediaLibraryImageUrl;
      } else {
        _classPrivateMethodGet(this, _uploadProgress, _uploadProgress2).call(this);
      }
    }
    toggleSelection(event) {
      event.stopPropagation();
      _classPrivateMethodGet(this, _toggleSelection, _toggleSelection2).call(this);
    }
    toggleStarred(event) {
      event.stopPropagation();
      if (this.media.isStarred) {
        this.args.removeStarred(this.media);
      } else {
        this.args.addStarred(this.media);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "circle", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "media", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mediaUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStarred"), _class.prototype)), _class);
  function _drawProgressCircle2() {
    const progressElem = document.getElementById(this.progressCircleUUID);
    if (!(0, _utils.isNone)(progressElem)) {
      //first pass it might not have rendered yet -iMack
      const circle = new _progressbar.default.Circle(progressElem, {
        svgStyle: {
          position: 'absolute',
          top: '35%',
          left: '35%',
          width: '30%'
        },
        color: '#BFC9D3',
        strokeWidth: 5,
        trailWidth: 5
      });
      this.circle = circle;
    }
  }
  function _select2() {
    if (!this.isSelected) {
      this.args.addSelection(this.media);
    }
  }
  function _toggleSelection2() {
    if (this.isSelected) {
      this.args.removeSelection(this.media);
    } else {
      this.args.addSelection(this.media);
    }
  }
  function _uploadProgress2() {
    _classPrivateMethodGet(this, _select, _select2).call(this);
    if (this.media?.isUploading) {
      if (!(0, _utils.isNone)(this.circle)) {
        this.circle.animate(this.media.uploadProgress);
      } else if (this.media?.uploadProgress < 1.0) {
        _classPrivateMethodGet(this, _drawProgressCircle, _drawProgressCircle2).call(this);
      } else if (this.media?.uploadProgress >= 1) {
        _classPrivateMethodGet(this, _toggleSelection, _toggleSelection2).call(this);
      }
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AssetCardComponent);
});